import React, { useState, useEffect } from "react";
import { CommonInput, CommonModal, CustomSelect } from "components";
import { errorSchema, utils } from "helper";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import StorageService from "utils/StorageServices/StorageServices";
import { addAssociationSchema } from "helper/errorSchema";
import { addAssociateFirmApi, updateAssociateFirmApi } from "_services/accountsServices/firmServices";

const AddAssociationModal = (props) => {
  const { firmList, toFirmList, onSubmitSuccess, currentFirmDetails, CallBackApi, isOpen, mode } = props;

  const initial = {
    company_id: StorageService?.getCompanyId(),
    from_firm_id: "",
    from_firm_name: "",
    to_firm_id: "",
    to_firm_name: "",
    pay_type: 1,
    opening_balance: "",
  };

  const dispatch = useDispatch();
  const [form, setForm] = useState(initial);
  const [formError, setFormError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [firmOptions, setFirmOptions] = useState([]);

  // Set firm options
  useEffect(() => {
    if (firmList) {
      const options = firmList
        ?.filter((f) => f?._id !== currentFirmDetails?._id)
        ?.filter((firm) => {
          // Filter out firms that are already in toFirmList
          return !toFirmList?.some((to) => to?.to_firm?._id === firm?._id);
        });

      const associateFirmFilter = options?.map((firm) => {
        return {
          ...firm,
          label: firm?.firm || firm?.name,
          value: firm?._id || firm?.id,
        };
      });

      setFirmOptions(associateFirmFilter || []);
    }
  }, [firmList, currentFirmDetails, toFirmList]);

  // Handle mode changes
  useEffect(() => {
    if (isOpen?._id) {

      setForm({
        company_id: isOpen?.company_id || StorageService?.getCompanyId(),
        from_firm_id: isOpen?.from_firm?._id || "",
        from_firm_name: isOpen?.from_firm?.firm || "",
        to_firm_id: isOpen?.to_firm?._id || "",
        to_firm_name: isOpen?.to_firm?.firm || "",
        pay_type: isOpen?.pay_type || 1,
        opening_balance: isOpen?.opening_balance?.toString() || "",
      });
    } else if (isOpen === true) {
      // Add mode - reset form

      setFormError("");
      setForm({
        ...initial,
        from_firm_id: currentFirmDetails?._id,
        from_firm_name: currentFirmDetails?.firm,
      });
    }
  }, [isOpen, currentFirmDetails, mode]);

  const handleOnChange = async (name, value, extraData = {}) => {
    const stateObj = {
      ...form,
      [name]: value,
      ...extraData,
    };

    setForm(stateObj);

    if (!!formError) {
      const validationResult = await utils.checkFormError(
        { ...stateObj },
        addAssociationSchema
      );

      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const handleSubmit = async () => {
    const validationResult = await utils.checkFormError(
      { ...form },
      addAssociationSchema
    );

    if (validationResult !== true) {
      setFormError(validationResult);
      return;
    }

    const payload = {
      company_id: StorageService?.getCompanyId(),
      from_firm: {
        _id: form?.from_firm_id,
        firm: form?.from_firm_name,
      },
      to_firm: {
        _id: form?.to_firm_id,
        firm: form?.to_firm_name,
      },
      pay_type: form?.pay_type,
      opening_balance: parseFloat(form?.opening_balance) || 0,
    };


    const editPayload = {
      company_id: StorageService?.getCompanyId(),
      interfirm_id: isOpen._id,
      pay_type: form?.pay_type,
      opening_balance: parseFloat(form?.opening_balance) || 0,
    }
    // Add _id if in edit mode
    if (mode == "edit" && isOpen?._id) {
      payload.interfirm_id = isOpen._id;
    }

    setIsLoading(true);
    try {
      const res = mode != "edit" ? await addAssociateFirmApi(payload) : await updateAssociateFirmApi(editPayload);
      if (res?.responseCode == 200) {
        toast.success(
          mode === "edit"
            ? "Association updated successfully"
            : "Association added successfully"
        );
        CallBackApi();
        props?.closeModal();
        onSubmitSuccess && onSubmitSuccess();
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  // Switch from view to edit mode
  const handleEnableEdit = () => {
    handleSubmit()
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };



  const propsModal = {
    ...props,
    isLoadding: isLoading,
    onSubmit: mode == "edit" ? handleEnableEdit : handleSubmit,
    disabled: mode == "view"
  };

  return (
    <>
      <CommonModal {...propsModal}>
        <div className="addBankAcc_body">
          <div className="_allDflx">
            <div style={{ marginTop: "20px" }}>
              <CustomSelect
                label="Firm"
                placeholder="Select Firm"
                isDropdownTop={false}
                options={firmOptions}
                value={
                  form?.to_firm_id
                    ? firmList?.find((i) => i?._id === form?.to_firm_id)
                    : { label: "", value: "" }
                }
                onSelect={(data) => {
                  handleOnChange("to_firm_id", data?.value, {
                    to_firm_name: data?.label,
                  });
                }}
                focus={!!formError?.to_firm_id}
                error={formError?.to_firm_id}
                disabled={mode != "add"}
              />
            </div>
            <div style={{ marginTop: "10px" }}>
              <label
                style={{
                  display: "block",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#333",
                }}
              >
                Select Type
              </label>
              <div className="checkBx_lv" style={{ display: "flex", gap: "20px" }}>
                <div className="_dualCheckr_bx">
                  <input
                    className="form-check-input"
                    id="need_to_take"
                    type="radio"
                    name="pay_type"
                    checked={form?.pay_type === 1}
                    value={1}
                    onChange={({ target: { name, value } }) =>
                      handleOnChange(name, parseInt(value))
                    }
                    disabled={mode == "view"}
                  />
                  <label
                    htmlFor="need_to_take"
                    className="form-check-label"
                    style={{ marginLeft: "8px", cursor: mode == "view" ? "not-allowed" : "pointer" }}
                  >
                    Need to Take
                  </label>
                </div>

                <div className="_dualCheckr_bx">
                  <input
                    className="form-check-input"
                    id="need_to_pay"
                    type="radio"
                    name="pay_type"
                    checked={form?.pay_type === 2}
                    value={2}
                    onChange={({ target: { name, value } }) =>
                      handleOnChange(name, parseInt(value))
                    }
                    disabled={mode == "view"}
                  />
                  <label
                    htmlFor="need_to_pay"
                    className="form-check-label"
                    style={{ marginLeft: "8px", cursor: mode == "view" ? "not-allowed" : "pointer" }}
                  >
                    Need to Pay
                  </label>
                </div>
              </div>
            </div>
            <div style={{ marginTop: "10px" }}>
              <CommonInput
                label="Opening Balance"
                type="text"
                name="opening_balance"
                placeholder="Opening Balance"
                maxLength={10}
                onInput={maxLengthCheck}
                value={form.opening_balance}
                onChange={({ target: { name, value } }) => {
                  if (/^\d*\.?\d*$/.test(value)) {
                    handleOnChange(name, value);
                  }
                }}
                focus={!!formError?.opening_balance}
                error={formError?.opening_balance}
                disabled={mode == "view"}
              />
            </div>
          </div>
        </div>
      </CommonModal>
    </>
  );
};

export default AddAssociationModal;